import { getBuilderJson } from './getBuilderJson';

export const getFilterBarContent = async (filterBarEnabled, ctx, asPath) => {
  if (filterBarEnabled) {
    return await getBuilderJson(
      { modelName: 'bmig-grid-filter-bar', urlPath: asPath.split('?')[0] },
      ctx
    );
  }
};
